/** Máximo de pré-pedidos por exportação (evita timeout no navegador). */
export const PRE_PEDIDOS_EXPORT_MAX = 2000;

export const PRE_PEDIDOS_EXPORT_PAGE_SIZE = 100;

/** Requisições simultâneas ao buscar detalhes para o relatório. */
export const PRE_PEDIDOS_EXPORT_DETAIL_CONCURRENCY = 6;
